import Telephone from '../assets/img/telephone.png';
import Mail from '../assets/img/mail.png';
import { FaFacebookF, FaTwitter } from 'react-icons/fa';
import { TfiLinkedin } from "react-icons/tfi";
import { AiFillInstagram } from "react-icons/ai";



export const menu = [
    {
        title: 'Home',
        link: '/#homeTop'
    },
    {
        title: 'Solutions',
        link: '/#solutions'
    },
    {
        title: 'Industries',
        link: '/#industries'
    },
    {
        title: 'Why BR&V',
        link: '/#why-brandv'
    },
    {
        title: 'About Us',
        link: '/#about-us'
    },
    {
        title: 'Contact',
        link: '/#contact'
    },
]

export const policyMenu = [
    {
        title: 'Terms and Conditions',
        link: '/terms-and-conditions'
    },
    {
        title: 'Privacy Policy',
        link: '/privacy-policy'
    },
    {
        title: 'Return and Refund Policy',
        link: '/return-and-refund-policy'
    },
    {
        title: 'Dispute Resolution Policy',
        link: '/dispute-resolution-policy'
    },
]

export const menuFooter = [
    {
        icon: Telephone,
        title: 'Call Us',
        text: '+63 994 090 8740',
        link: 'tel:+639940908740'
    },
    {
        icon: Mail,
        title: 'Email Us',
        text: 'contact@brvtechnologysg.com',
        link: 'mailto:contact@brvtechnologysg.com'
    },
]

export const footerSocialIcons = [
    {
        icon:  FaFacebookF,
        link: ''
    },
    {
        icon:  FaTwitter,
        link: ''
    },
    {
        icon:  TfiLinkedin,
        link: ''
    },
    {
        icon:  AiFillInstagram,
        link: ''
    },
]
